/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionWithRelations } from '../../models/auction-with-relations';

export interface InventoryGetAuctions$Params {
  inventoryId: string;
}

export function inventoryGetAuctions(http: HttpClient, rootUrl: string, params: InventoryGetAuctions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, inventoryGetAuctions.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AuctionWithRelations>>;
    })
  );
}

inventoryGetAuctions.PATH = '/inventory/auctions';
